import ProductPrice from '@phoenix/components/common/ProductPrice.vue';
import { CURRENT_COUNTRY_CHANGED, emitter } from '@phoenix/event-bus';
import { get } from 'lodash-es';

export default {
  components: {
    ProductPrice,
  },

  props: {
    url: {
      type: String,
      required: true,
    },
    /**
     * `{ sources: [], src: '', alt: '', imgClass: '', lazy: '' }`
     */
    image: {
      type: Object,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    modelReference: {
      type: String,
      required: true,
    },
    sapReference: {
      type: String,
      required: true,
    },
    internalReference: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    /**
     * `{ en: '20 300 €', fr: '19 900 €', … }`
     */
    price: {
      type: Object,
      default: () => ({}),
    },
    shouldDisplayFromPrice: {
      type: Boolean,
      default: false,
    },
    tracking: {
      type: Object,
      default: null,
    },
    shouldDisplayAddToWishlist: {
      type: Boolean,
      default: true,
    },
    isMovement: {
      type: Boolean,
      default: false,
    },
    dataTracking: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      currentCountry: window.Phoenix.currentCountry,
    };
  },

  computed: {
    localizedPrice() {
      if (this.currentCountry && this.price?.[this.currentCountry]) {
        return this.price[this.currentCountry];
      }

      return '';
    },

    vatInformation() {
      return get(this.localizedPrice, 'vatInformation', '');
    },

    shouldDisplayVatInformation() {
      return this.vatInformation !== '';
    },
  },

  created() {
    emitter.on(CURRENT_COUNTRY_CHANGED, this.onCountryChanged);
  },

  unmounted() {
    emitter.off(CURRENT_COUNTRY_CHANGED, this.onCountryChanged);
  },

  methods: {
    onCountryChanged(country) {
      this.currentCountry = country;
    },
  },
};
